"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("circle", {
        stroke: "#016b6a",
        cx: 12,
        cy: 12,
        r: 11
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M12.833 18h-1.7V8.273h.95c.667 0 .75.223.75 1.45V18ZM12 7.195c-.533 0-1-.484-1-1.08C11 5.503 11.467 5 12 5c.533 0 1 .502 1 1.116 0 .595-.467 1.079-1 1.079Z",
        fill: "#016b6a"
      })]
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};